import React from 'react';
import sageIcon from '../../assets/images/sage-icon.png';

export default function SageIcon({ size = 18, className = '', alt = '' }) {
  return (
    <img
      src={sageIcon}
      alt={alt}
      width={size}
      height={size}
      className={`mg-sage-icon${className ? ` ${className}` : ''}`}
      aria-hidden={alt ? undefined : true}
      draggable={false}
    />
  );
}
